import React from 'react';
import styled from 'styled-components';
import {Button, Layout} from 'antd';
import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';

import {useAppStore} from 'hooks/app-store';
import {useAccountStore} from 'hooks/account-store';

const {Header} = Layout;

const StyledHeader = styled(Header)`
    display: flex;
    padding-left: 16px !important;
    padding-right: 16px !important;
    background: white !important;
`;

const StyledButtons = styled(Button)`
    margin-top: auto !important;
    margin-bottom: auto !important;
`;

export function Topbar() {
    const appStore = useAppStore();
    const accountStore = useAccountStore();
    let icon = <MenuUnfoldOutlined/>;

    if (appStore.sidebarOpen) {
        icon = <MenuFoldOutlined/>;
    }

    const name = accountStore.account?.username;
    const roles = accountStore.account?.roles?.map(el => el.tag).join(' ');

    return (
        <StyledHeader>
            <StyledButtons
                type="ghost"
                onClick={appStore.toggleSidebar}
            >
                {icon}
            </StyledButtons>
            <p style={{marginLeft: 'auto', marginRight: 16}}>
                {name} ({roles})
            </p>
            <StyledButtons
                onClick={accountStore.logout}
            >
                Logout
            </StyledButtons>
        </StyledHeader>
    );
}